__turbopack_context__.v({
  "className": "testdiegrotesk_df96495a-module__Pl8E7W__className",
  "variable": "testdiegrotesk_df96495a-module__Pl8E7W__variable",
});
